import { TableColumn, TableConfig } from '../../../../../@shared/models/table.models';

export const TEMPLATE_LIBRARY_TABLE_COLUMNS: TableColumn[] = [
    {
        field: "id",
        header: "Template ID",
        type: "custom",
        template: "templateIdTemplate",
        width: "15%",
        sortable: true
    },
    {
        field: "name",
        header: "Template name",
        type: "custom",
        template: "templateNameTemplate",
        width: "25%",
        sortable: true
    },
    {
        field: "timesused",
        header: "Template usage",
        type: "custom",
        template: "templateUsageTemplate",
        width: "15%",
        sortable: true
    },
    {
        field: "createAt",
        header: "Created date",
        type: "custom",
        template: "createdDateTemplate",
        width: "20%",
        sortable: true
    },
    {
        field: "createdBy",
        header: "Created by",
        type: "custom",
        template: "createdByTemplate",
        width: "20%"
    },
    {
        field: "actions",
        header: "Actions",
        type: "custom",
        template: "actionsTemplate",
        width: "5%"
    }
];

export const TEMPLATE_LIBRARY_TABLE_CONFIG: TableConfig = {
    selectable: true,
    selectionOnRowClick: false,
    paginator: true,
    rows: 20,
    rowsPerPageOptions: [20, 30, 40],
    scrollable: true,
    scrollHeight: "100%",
    loading: false,
    emptyMessage: "No templates found",
    globalFilter: false,
    responsive: true
};


